<template>
  <!-- <div style="width: 100%; text-align: center"> -->
  <button class="buttonGeneralB" :disabled="this.disabled || false">
    <p class="p-botones" style="color: #fff">{{ texto }}</p>
  </button>
  <!-- </div> -->
</template>
<script>
export default {
  name: "BtnBComponent",
  props: {
    texto: String,
    disabled: Boolean,
    modal: Boolean,
  },
};
</script>
<style scoped>
.buttonGeneralB {
  height: var(--margin40);
  background: var(--backgroundGrisGradient);
  border-radius: 0.625rem;
  text-align: center;
  align-content: center;
  width: 17vw;
  border: none;
  height: 8.33vh;
}

@media (max-width: 990px) {
  .buttonGeneralB {
    width: 18vw;
  }
}

@media (max-width: 770px) {
  .buttonGeneralB {
    /* margin: auto; */
    background: var(--verdeGradient);
    border-radius: 8px;
    text-align: center;
    align-content: center;
    min-width: 44vw;
    border: none;
    height: 7.3vh;
  }
}

@media (max-width: 460px) {
  .buttonGeneralB {
    min-width: 41.5vw;
    height: 5.843vh;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  }
}
</style>
